import React from 'react';
import { Form } from 'react-bootstrap';

const MonthlyRepeatTypeSelector = ({ enableDaysOfWeek, setEnableDaysOfWeek }) => {
  return (
    <div className="d-flex justify-content-between align-items-center mb-2">
      <Form.Label className="fw-bold text-white mb-1 mb-0">Repeat</Form.Label>
      <div className="d-flex align-items-center">
        <Form.Check
          type="radio"
          id="monthly-each"
          label="Each"
          name="monthly-repeat-type"
          checked={!enableDaysOfWeek}
          onChange={() => setEnableDaysOfWeek(false)}
          className="me-3"
        />
        <Form.Check
          type="radio"
          id="monthly-on-the"
          label="On the"
          name="monthly-repeat-type"
          checked={enableDaysOfWeek}
          onChange={() => setEnableDaysOfWeek(true)}
        />
      </div>
    </div>
  );
};

export default MonthlyRepeatTypeSelector;
